var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPreview(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9167 4H7.58333C6.7125 4 6 4.7125 6 5.58333V18.25C6 19.1208 6.70458 19.8333 7.57542 19.8333H17.0833C17.9542 19.8333 18.6667 19.1208 18.6667 18.25V8.75L13.9167 4ZM17.0833 18.25H7.58333V5.58333H13.125V9.54167H17.0833V18.25Z",
    className: "fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9573 16.5449L13.9238 14.5114C14.3095 14.0353 14.5417 13.4299 14.5417 12.7708C14.5417 11.243 13.2987 10 11.7708 10C10.243 10 9 11.243 9 12.7708C9 14.2987 10.243 15.5417 11.7708 15.5417C12.4299 15.5417 13.0353 15.3095 13.5114 14.9238L15.5449 16.9573C15.6018 17.0142 15.6941 17.0142 15.7511 16.9573L15.9573 16.7511C16.0142 16.6941 16.0142 16.6018 15.9573 16.5449Z",
    className: "stroke"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreview);
export default __webpack_public_path__ + "static/media/preview.d2123a930efd32509a60fbbcf3470ef6.svg";
export { ForwardRef as ReactComponent };